<template>
  <v-avatar size="31">
    <img :src="src" alt="avatar" style='background-color: #fff' />
  </v-avatar>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    src: { type: String, required: true }
  }
}
</script>
